import React from "react";
import CustomInput from "../forms/CustomInput";
import { West } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import CustomButton from "../forms/CustomButton";
import BasicModal from "../Modal";
import { showModal } from "../../../app/home/HomeAction";
import { useDispatch } from "react-redux";
import sentIcon from "../../../assets/images/request-sent.svg";
import { toast } from "react-toastify";
import { emailRegex, phoneRegex } from "../../Constant";
import postLoginInstance from "../../PostLoginAxios";

const ReferModal = ({ back }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [sent, setSent] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [name, setName] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const [phone, setPhone] = React.useState("");

  const handleSendInvite = () => {
    setLoading(true);
    if (email !== "" && emailRegex.test(email) === false) {
      return toast.info("Invalid Email");
    }
    if (
      companyName !== "" &&
      (companyName.length < 3 || companyName.length > 100)
    ) {
      return toast.info("Invalid Company Name");
    }
    if (name !== "" && (name.length < 3 || name.length > 40)) {
      return toast.info("Invalid Name");
    }
    if (phone !== "" && phoneRegex.test(phone) === false) {
      return toast.info("Invalid Phone");
    }
    try {
      postLoginInstance.post("/company/send-referal", {
        email,
        contactPerson: name,
        companyName: companyName,
        phone: phone,
      });
      setSent(true);
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {sent && (
        <BasicModal
          className={"invite-modal"}
          open={sent}
          handleClose={() => {
            dispatch(showModal(null));
            setSent(false);
          }}
          closeOnBackdropClick
        >
          <Sent />
        </BasicModal>
      )}
      <div className="invite-modal-box">
        <div className="pb-4">
          {isMobile ? (
            <div className="flex-row gap-12 align-center">
              <div onClick={() => back()}>
                <West></West>
              </div>
              <h1 className="f-s-16 manrope-bold">Refer</h1>
            </div>
          ) : (
            <h1 className="f-s-24 manrope-bold">Refer</h1>
          )}
        </div>
        <div className="">
          <div className="mb-4">
            <CustomInput
              heading={"Company Name"}
              placeholder={"Enter Company Name"}
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              error={
                companyName !== "" &&
                (companyName.length < 3 || companyName.length > 40) &&
                "Invalid Company Name"
              }
            ></CustomInput>
          </div>
          <div className="mb-4">
            <CustomInput
              heading={"Contact Person"}
              placeholder={"Enter Person Name"}
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={
                name !== "" &&
                (name.length < 3 || name.length > 40) &&
                "Invalid Name"
              }
            ></CustomInput>
          </div>
          <div className="mb-4">
            <CustomInput
              heading={"Email"}
              placeholder={"Enter Email ID"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={
                email !== "" &&
                emailRegex.test(email) === false &&
                "Use valid work email"
              }
            ></CustomInput>
          </div>
          <div className="mb-4">
            <CustomInput
              heading={"Contact"}
              placeholder={"Enter Phone Number"}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              error={
                phone  &&
                phoneRegex.test(phone) === false &&
                "Invalid Phone"
              }
            ></CustomInput>
          </div>
        </div>
        <div>
          <CustomButton
            className={"common-btn mt-4"}
            onClick={handleSendInvite}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Invite"}
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default ReferModal;

const Sent = () => {
  return (
    <div className="flex-col gap-10 justify-center align-center p-4">
      <img src={sentIcon} alt="" />
      <h1 className="f-s-24 manrope-bold">Request Sent</h1>
    </div>
  );
};
